import { render, staticRenderFns } from "./tenderInfo.vue?vue&type=template&id=143bcda6&scoped=true&"
import script from "./tenderInfo.vue?vue&type=script&lang=js&"
export * from "./tenderInfo.vue?vue&type=script&lang=js&"
import style0 from "./tenderInfo.vue?vue&type=style&index=0&id=143bcda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143bcda6",
  null
  
)

export default component.exports